module.exports = __webpack_public_path__ + "media/images/zj11-c4-85b7673064c0c98337c64fcf957a48ac.png";